import { getApps, initializeApp } from 'firebase/app';
import type { FirebaseApp } from 'firebase/app';

export interface FirebaseConfig {
  apiKey: string;
  appId: string;
  authDomain: string;
  messagingSenderId: string;
  projectId: string;
  storageBucket: string;
}

/**
 * Initialize Firebase (or return existing app if already initialized).
 * Designed to be called once at app startup.
 *
 * @param config - Firebase configuration
 * @param appName - Optional app name for isolation (defaults to '[DEFAULT]').
 *   Pass a distinct name per app (e.g. 'backoffice', 'frontoffice') when multiple
 *   Firebase apps run on the same origin to prevent IndexedDB auth-state collisions.
 */
export function initializeFirebase(config: FirebaseConfig, appName?: string): FirebaseApp {
  const name = appName?.trim() || '[DEFAULT]';
  const existing = getApps().find((app) => app.name === name);
  if (existing) {
    return existing;
  }
  return initializeApp(config, name);
}
